<template>
  <div class="plans">
    <v-card ref="plans">
      <v-toolbar fixed flat color="white" style="border-radius:0px">
        <v-btn icon dark @click="close()">
          <v-icon color="black">mdi-close</v-icon>
        </v-btn>
        <v-img max-height="38" max-width="100" src="~/img/wiom_logo.png" style="margin: 0px auto;"></v-img>
      </v-toolbar>
      <v-card-text
        class="plans-content"
        style="height:100%;max-height: auto;padding:0px; margin:0px auto;"
      >
        <div v-if="view == 'welcome'" class="plans-title">Wi-Fi Control</div>
        <v-img
          v-if="view == 'welcome'"
          width="207"
          src="~/img/wificontrol.png"
          style="margin: 0px auto;"
        ></v-img>
        <div
          v-if="view == 'welcome'"
          style="width:300px;margin:0px auto;margin-top:25px;color:#484848;font-size:14px"
        >
          Internet control now on your phone. Check Data
          usage, Data limit, Total user and many more…
        </div>
        <div v-if="view == 'welcome'" style="width:96px;margin:0px auto;margin-top:24px;">
          <v-img
            width="16px"
            src="~/img/icons/network.svg"
            style="display:inline-block;margin-right:7px;"
          ></v-img>
          <v-img
            width="16px"
            src="~/img/icons/calendar.svg"
            style="display:inline-block;margin-right:7px;"
          ></v-img>
          <v-img
            width="16"
            src="~/img/icons/timer.svg"
            style="display:inline-block;margin-right:7px;"
          ></v-img>
          <v-img
            width="16"
            src="~/img/icons/mobile.svg"
            style="display:inline-block;margin-right:0px;"
          ></v-img>
        </div>
        <div
          style="font-weight:bold;font-size:20px;color:#000;text-align:center;margin-top:40px"
        >Choose your Plan</div>
        <Plan v-bind:data="basicPlanData" @learn="learn('basic', $event)"></Plan>
        <Plan v-bind:data="proPlanData" @buy="buy('magic',$event)" @learn="learn('magic', $event)"></Plan>
        <v-dialog
          v-model="showDetails"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          app
        >
          <Details v-bind:data="selectedPlan" @close="showDetails = false"></Details>
        </v-dialog>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import Plan from "./../common/plans/PlanUnit";
import Details from "./../common/plans/Details";
export default {
  name: "Plans",
  components: {
    Plan,
    Details
  },
  props: ["view", "location", "owner"],
  data: function() {
    return {
      showDetails: false,
      basicPlanData: {
        id: "basic",
        pricing: 0,
        name: "basic",
        active: true,
        purchasable: false,
        features: [
          "Mobile OTP User authentication",
          "Set maximum daily data usage limit",
          "Get basic user report"
        ],
        fullFeatures: [
          "12-month basic service subscription ",
          "Phone number OTP based user authentications ",
          "Set maximum daily data usage limit ",
          "Plug & Play set up, compatible with broadband & 3G/4G dongles",
          "Easily manage your Wi-Fi SSID Name & Password",
          "Get basic user report",
          "No-questions-asked replacement warranty for 1 year"
        ],
        specs: [
          { specification: "Item Weight", detail: "671 g" },
          {
            specification: "Product Dimensions",
            detail: "31.7 x 24.1 x 6.8 cm"
          },
          { specification: "Item model number", detail: "WIOM Basic" },
          { specification: "Computer Memory Type", detail: "DDR3 SDRAM" },
          { specification: "Processor Count", detail: "1" },
          {
            specification: "Included Components",
            detail:
              "Router, 2 Antennas,Power supply unit, Ethernet Cable Quick Installation Guide 4 Free Wi-Fi Stickers"
          },
          { specification: "Voltage", detail: "110 Volts" },
          { specification: "Wattage", detail: "12" },
          {
            specification: "Data Transfer Rate",
            detail: "300 megabits_per_second"
          },
          { specification: "Wireless Type", detail: "802.11n" },
          {
            specification: "Data Link Protocol",
            detail: "Wi-Fi, Usb, Ethernet"
          },
          { specification: "GSM frequencies", detail: "2.4 GHz" },
          { specification: "Number of Ports", detail: "5" },
          { specification: "Total Usb Ports", detail: "1" },
          { specification: "Includes AC Adapter", detail: "Yes" },
          { specification: "Radio Bands Supported", detail: "Single Band" },
          {
            specification: "Form Factor",
            detail: "Cloud Controlled Wi-Fi Solution"
          },
          { specification: "Warranty", detail: "1 year" }
        ],
        border: "#f06b69",
        free: true,
        recommended: false
      },
      proPlanData: {
        id: "magic",
        pricing: 2999,
        name: "magic",
        active: false,
        purchasable: true,
        features: [
          "Customize your WiFi",
          "Track your customer",
          "Earn from your WiFi connection"
        ],
        fullFeatures: [
          "12 months advance service subscription",
          "Phone Number-OTP based user authentication - Unlimited Free SMS authentications for 3 months",
          "Advance features for preventing mis-use: Easily set data limit, time limit, user blocking, and more with the simple mobile app",
          "Ultimate Business Booster: Show your logo, promotions, offers, menu, etc. to customers on the Wi-Fi login. Also, get customer data for marketing activities",
          "Completely Plug & Play: Set up in just 2 minutes - no technical expertise ",
          "Compatible with broadband, JioFi, Vodafone's MiFi, Airtel 4G, all other 3G/4G dongles",
          "No-questions-asked replacement warranty for 1 year"
        ],
        specs: [
          { specification: "Item Weight", detail: "671 g" },
          {
            specification: "Product Dimensions",
            detail: "31.7 x 24.1 x 6.8 cm"
          },
          { specification: "Item model number", detail: "WIOM Magic" },
          { specification: "Computer Memory Type", detail: "DDR3 SDRAM" },
          { specification: "Processor Count", detail: "1" },
          {
            specification: "Included Components",
            detail:
              "Router, 2 Antennas,Power supply unit, Ethernet Cable Quick Installation Guide 4 Free Wi-Fi Stickers"
          },
          { specification: "Voltage", detail: "110 Volts" },
          { specification: "Wattage", detail: "12" },
          {
            specification: "Data Transfer Rate",
            detail: "300 megabits_per_second"
          },
          { specification: "Wireless Type", detail: "802.11n" },
          {
            specification: "Data Link Protocol",
            detail: "Wi-Fi, Usb, Ethernet"
          },
          { specification: "GSM frequencies", detail: "2.4 GHz" },
          { specification: "Number of Ports", detail: "5" },
          { specification: "Total Usb Ports", detail: "1" },
          { specification: "Includes AC Adapter", detail: "Yes" },
          { specification: "Radio Bands Supported", detail: "Single Band" },
          {
            specification: "Form Factor",
            detail: "Cloud Controlled Wi-Fi Solution"
          },
          { specification: "Warranty", detail: "1 year" }
        ],
        comparison: [
          { feature: "Subscription Month", basic: "1 year", pro: "1 year" },
          { feature: "Change Wi-Fi Name", basic: "✓", pro: "✓" },
          { feature: "Set Wi-Fi Password", basic: "✓", pro: "✓" },
          { feature: "Phone number /OTP Authentication", basic: "✓", pro: "✓" },
          {
            feature: "Customized login page with brand logo ",
            basic: "X",
            pro: "✓"
          },
          { feature: "Show promotion and coupons", basic: "X ", pro: "✓" },
          { feature: "Custom landing page ", basic: "X ", pro: "✓" },
          { feature: "Customer data for marketing", basic: "X", pro: "✓" },
          { feature: "Overall data restriction per day", basic: "✓", pro: "✓" },
          { feature: "User level data control", basic: "X", pro: "✓" },
          {
            feature: "Session duration and number limit",
            basic: "X",
            pro: "✓"
          },
          { feature: "Number of device limit", basic: "X", pro: "✓" },
          { feature: "Automatically login neXt time", basic: "X", pro: "✓" },
          { feature: "Change login page language", basic: "X", pro: "✓" },
          {
            feature: "Blocking users and VIP access to users",
            basic: "X",
            pro: "✓"
          },
          { feature: "Basic user report", basic: "✓", pro: "✓" },
          { feature: "Detailed user reports", basic: "X", pro: "✓" }
        ],
        border: "#68d391",
        free: false,
        recommended: true
      },
      selectedPlan: this.basicPlanData
    };
  },
  methods: {
    close: function() {
      this.$emit("close");
    },
    learn: function(what, data) {
      what = null;
      this.selectedPlan = data;
      this.showDetails = true;
    },
    buy: function() {
      window.open(`https://wiom.in/wiompayment/subscriptions?pid=10004&nasid=${this.location.nasid}`);
    }
  }
};
</script>
